import HttpService from '@/api/HttpService';

export default {
  namespaced: true,
  state: {
    sessionId: null,
    questions: [],
    expiresAt: null,
    loading: false,
    error: null,
  },
  mutations: {
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_SESSION_ID(state, id) {
      state.sessionId = id;
    },
    SET_QUESTIONS(state, payload) {
      state.questions = payload.questions || [];
      state.expiresAt = payload.expiresAt || null;
    },
    RESET(state) {
      state.sessionId = null;
      state.questions = [];
      state.expiresAt = null;
      state.loading = false;
      state.error = null;
    },
  },
  actions: {
    async initiate({ commit }, { dwollaCustomerId }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const res = await HttpService.postV2('kba/initiate', { dwollaCustomerId });
        const { dwollaKbaId } = res || {};
        commit('SET_SESSION_ID', dwollaKbaId);
        return dwollaKbaId;
      } catch (err) {
        commit('SET_ERROR', err);
        throw err;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async getQuestions({ commit, state }, { sessionId }) {
      const id = sessionId || state.sessionId;
      if (!id) throw new Error('Missing KBA session id');
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const res = await HttpService.getV2(`kba/${id}/questions`);
        const { questions = [], expiresAt = null } = res || {};
        commit('SET_QUESTIONS', { questions, expiresAt });
        return { questions, expiresAt };
      } catch (err) {
        commit('SET_ERROR', err);
        throw err;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async submitAnswers({ commit, state }, { sessionId, answers }) {
      const id = sessionId || state.sessionId;
      if (!id) throw new Error('Missing KBA session id');
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      try {
        const res = await HttpService.postV2(`kba/${id}/answers`, { answers });
        return res;
      } catch (err) {
        commit('SET_ERROR', err);
        throw err;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/kba.js